import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as LogRocket from 'logrocket';

import { enableProdMode, isDevMode } from '@angular/core';
import { LogLevel, setLogLevel } from '@angular/fire';
import * as Honeybadger from '@honeybadger-io/js';
import packageJson from '@vmspdb/package-json';
import { GlobalErrorHandlerService, logRocketOptions } from '@vmspdb/ui/common';
import { AppModule } from './app/app.module';
import { InitializerService } from './app/services/initializer.service';
import { getAppName } from './app/shared/utils';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// AngularFire only reports calls outside an injection context at WARN for
// blocking APIs; everything else logs at VERBOSE. Surface them all in dev and
// e2e builds (production keeps AngularFire's SILENT default).
if (isDevMode()) {
  setLogLevel(LogLevel.VERBOSE);
}

(async () => {
  if (!isDevMode()) {
    // Configured before the Firebase config loads so a failed load is still
    // reported. Until then getAppName() can only guess from the hostname, so
    // the environment is corrected once the config is in.
    Honeybadger.configure({
      apiKey: 'hbp_rIJkNPgUwgt9qJRQkU925qAyZ6dow51L1eui',
      developmentEnvironments: ['vms-web-app'],
      environment: getAppName(),
    });
  }

  // Load firebase config
  await InitializerService.load();

  if (!isDevMode()) {
    const appName = getAppName();
    LogRocket.init(
      `6ocqah/${appName}`,
      logRocketOptions(`${packageJson.version}-${environment.firebase.appId}`),
    );
    LogRocket.track(`app-frontend`);
    Honeybadger.configure({ environment: appName });
    LogRocket.getSessionURL((sessionURL) => {
      Honeybadger.beforeNotify((notice) => {
        if (!notice) return;
        notice.context['sessionURL'] = sessionURL;
      });
    });
    console.log('Initializing LogRocket / HoneyBadger');
  }

  await platformBrowserDynamic().bootstrapModule(AppModule);
})().catch((err) => {
  const loadingSpan: HTMLSpanElement | null = document.querySelector(
    'vmspdb-root>span.loading',
  );

  if (loadingSpan) {
    loadingSpan.innerText = `There was an error loading the app: ${err}.\nPlease reload and try again`;
  }

  const reporter = new GlobalErrorHandlerService();
  reporter.reportCatastrophicError(err, 'Site Load');
  console.error(err);
});
